/* src/app/modules/display/components/display/display.component.scss */
/*# sourceMappingURL=display.component.css.map */
